import script from "./ShopProductInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopProductInfo.vue?vue&type=script&setup=true&lang=js"

import "./ShopProductInfo.vue?vue&type=style&index=0&id=d16e2344&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d16e2344"]])

export default __exports__